module.exports = __webpack_public_path__ + "static/img/GettyImages-527045000.777e3d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/GettyImages-527045000.jpg
// module id = PiIy
// module chunks = 0